import { HEADER_CONFIG, meta } from '../../constants';
import type { PreparedSourceType } from '../data';
import type { SourceValue } from '../data/sources';
import { previewSources as previewSourcesMap } from '../data/sources';

export function checkHeaderAvailability(
  sources?: SourceValue[] | PreparedSourceType[],
  previewSourceKeys?: string[]
) {
  const { alias } = meta;
  const { hasHeader, connectionTypes } = HEADER_CONFIG[alias];

  const actualSources =
    sources && sources.length > 0
      ? sources
      : (previewSourceKeys || [])
          .map((key) => previewSourcesMap[key]?.source)
          .filter(Boolean);

  if (actualSources.length === 0) {
    return hasHeader;
  }

  const notAvailable =
    actualSources.length > 1 || !hasHeader || connectionTypes.length === 0;

  if (notAvailable) {
    return false;
  }

  const [source] = actualSources;

  return connectionTypes.includes(source.connectionType);
}
